﻿import React, { ChangeEvent, FormEvent } from 'react';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';

type UploadVideoFormLabels = {
    buttonLabel: string;
};

type UploadVideoFormProps = {
    onChangeFile: (file: File) => void;
    labels: UploadVideoFormLabels;
    inputId: string;
};

function UploadVideoForm({ labels, onChangeFile, inputId }: UploadVideoFormProps) {
    function handleSubmit(event: FormEvent) {
        event.preventDefault();
    }

    function handleChange(event: ChangeEvent<HTMLInputElement>) {
        onChangeFile(event.target.files[0]);
    }

    return (
        <form onSubmit={handleSubmit} style={{ padding: '8px' }}>
            <Button variant="text" size="small" color="primary" sx={{ padding: '4px 6px' }}>
                <InputLabel
                    htmlFor={inputId}
                    sx={{
                        width: '100%',
                        height: '100%',
                        cursor: 'pointer',
                        fontSize: '14px'
                    }}
                    style={{ marginBottom: 0 }}
                >
                    {labels.buttonLabel}
                    <input
                        onChange={handleChange}
                        id={inputId}
                        type="file"
                        name="file"
                        accept="*"
                        style={{ display: 'none' }}
                    />
                </InputLabel>
            </Button>
        </form>
    );
}

export default UploadVideoForm;
